import CertsSearchBar from './CertsSearchBar';

export default CertsSearchBar;
